import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { featureKey, reducers } from '../dashboards/store/reducers/index'
import { EffectsModule } from '@ngrx/effects'
import { DashboardOverviewEffects } from '../dashboards/store/effects/dashboard-overview.effects'

const EFFECTS = [DashboardOverviewEffects]

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(featureKey, reducers), EffectsModule.forFeature(EFFECTS)],
})
export class DashboardOverviewNgrxModule {}
